import React, { useEffect, useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const homeUrl = process.env.REACT_APP_HOME_URL;
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

const formatDate = (dateStr) =>
  new Date(dateStr).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

const GuideDetails = () => {
  const { slug } = useParams();
  const [guide, setGuide] = useState(null);
  const [latest, setLatest] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    fetch(`${adminApiUrl}/guides`)
      .then(res => res.json())
      .then(guides => {
        const matched = guides.find(g => g.slug === slug);
        if (!matched) throw new Error('Guide not found');
        setLatest(guides.filter(g => g.slug !== slug).slice(0, 5));
        return fetch(`${adminApiUrl}/guides/${matched.id}`);
      })
      .then(res => res.json())
      .then(data => setGuide(data))
      .catch(err => {
        console.error(err);
        setGuide(null);
      })
      .finally(() => setLoading(false));
  }, [slug]);

  const skeletonLoader = (
    <div className="skeleton-card">
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-8">
            <div className="skeleton skeleton-title mb-3"></div>
            <div className="skeleton skeleton-thumbnail mb-3"></div>
            {[...Array(8)].map((_, i) => (
              <div key={i} className="skeleton skeleton-text mb-2"></div>
            ))}
          </div>
          <div className="col-lg-4">
            <div className="skeleton skeleton-title mb-3"></div>
            {[...Array(3)].map((_, i) => (
              <div key={i} className="skeleton skeleton-thumbnail mb-3"></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  if (loading) return skeletonLoader;
  if (!guide) return <div className="container py-5">Guide not found.</div>;

  const imageUrl = guide.image
    ? `${homeUrl}admin/public/storage/${guide.image}`
    : `${homeUrl}admin/public/storage/default.jpg`;

  const pageUrl = `${homeUrl}guides/${guide.slug}`;

  return (
    <>
      <Helmet>
       <meta name="robots" content="index, follow" />
        <title>{guide.meta_title || guide.title}</title>
        <meta
          name="description"
          content={guide.meta_description || guide.content.replace(/<[^>]+>/g, '').slice(0, 150)}
        />
        <link rel="canonical" href={pageUrl} />
      </Helmet>

      <div className="articaldetails_wrapper">
        <div className="articaldetails_mainsec">
          <div className="container">
            <div className="row">
              {/* LEFT */}
              <div className="col-lg-8">
                <div className="detailspage_contnt">
                  <div className="breadcrumb_mainsec">
                    <ul>
                      <li><NavLink to="/guides">Guides</NavLink></li>
                      <li><span>{guide.title}</span></li>
                    </ul>
                  </div>

                  {guide.category && (
                    <div className="categorybox">
                      <div className="categorytxt">
                        <span>{guide.category.name}</span>
                      </div>
                    </div>
                  )}

                  <div className="imgbox">
                    <img src={imageUrl} alt={guide.title} />
                  </div>

                  <div className="author_info">
                    <div className="iconbox">
                      <i className="far fa-calendar"></i>
                      <span>{formatDate(guide.created_at)}</span>
                    </div>
                  </div>

                  <div className="contnt_box">
                    <h2>{guide.title}</h2>
                    <div dangerouslySetInnerHTML={{ __html: guide.content }} />
                  </div>

                  <div className="share_social_sec">
                    <span className="titletxt">Share:</span>
                    <ul>
                      {[
                        {
                          icon: 'fab fa-facebook-f',
                          url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`
                        },
                        {
                          icon: 'fab fa-linkedin-in',
                          url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(pageUrl)}`
                        },
                        {
                          icon: 'fab fa-twitter',
                          url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(pageUrl)}&text=${encodeURIComponent(guide.title)}`
                        },
                        {
                          icon: 'fab fa-telegram-plane',
                          url: `https://t.me/share/url?url=${encodeURIComponent(pageUrl)}&text=${encodeURIComponent(guide.title)}`
                        }
                      ].map(({ icon, url }) => (
                        <li key={icon}>
                          <a href={url} target="_blank" rel="noopener noreferrer">
                            <i className={icon}></i>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* RIGHT SIDEBAR */}
              <div className="col-lg-4">
                <div className="artical_sidebar">
                  <div className="latest_newsbox">
                    <div className="title_box"><h2>Latest Guides</h2></div>
                    <div className="articals_sec">
                      {latest.map(g => (
                        <div key={g.id} className="articals_mainbox">
                          <div className="articals_imgbox">
                            <img
                              src={g.image ? `${homeUrl}admin/public/storage/${g.image}` : `${homeUrl}assets/img/default.jpg`}
                              alt={g.title}
                            />
                          </div>
                          <div className="articals_contntbox">
                            <div className="artical_contnt">
                              <h3>
                                <NavLink to={`/guides/${g.slug}`}>{g.title}</NavLink>
                              </h3>
                            </div>
                            <div className="artical_info">
                              <span className="time_txt">{formatDate(g.created_at)}</span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GuideDetails;
